<div class="complete-order" *ngIf="currentOrder$ | async as currentOrder">
  <ng-container *ngIf="seenRecently$ | async; else promptGoHawk">
    <ng-container *ngIf="!currentOrder.loaded">
      <h3>Wait for Driver to Depart the Mine Geofence?</h3>
      <p>
        This driver has not yet picked up their load. If you complete this order, you will lose their in & out time at
        the loader and at the well. Please wait for the driver to depart the well and SANDi will automatically complete
        the load for you.
      </p>

      <div class="actions">
        <button mat-stroked-button color="warn" (click)="complete()">Complete Anyway</button>
        <button mat-stroked-button color="primary" [mat-dialog-close]="null">Wait for Driver</button>
      </div>
    </ng-container>
    <ng-container *ngIf="currentOrder.loaded">
      <ng-container *ngIf="isEtaArrived(currentOrder)">
        <h3>Wait for Driver to Depart the Well Geofence?</h3>
        <p>
          This driver is currently on location. If you complete this order, you will lose their in & out time. Please
          wait for the driver to depart the well and SANDi will automatically complete the load for you once they are 1
          mile away.
        </p>
        <div class="actions">
          <button mat-stroked-button color="warn" (click)="complete()">Complete Anyway</button>
          <button mat-stroked-button color="primary" [mat-dialog-close]="null">Wait for Driver</button>
        </div>
      </ng-container>
      <ng-container *ngIf="!isEtaArrived(currentOrder)">
        <h3>Wait for Driver to Arrive at the Well Geofence?</h3>
        <p>
          This driver's is expected to arrive at the well at {{ currentOrder.eta | eta }}. If you complete this order,
          you will lose their in & out time at the well. Please wait for the driver to depart the well and SANDi will
          automatically complete the load for you.
        </p>
        <div class="actions">
          <button mat-stroked-button color="warn" (click)="complete()">Complete Anyway</button>
          <button mat-stroked-button color="primary" [mat-dialog-close]="null">Wait for Driver</button>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</div>

<ng-template #promptGoHawk>
  <h3>Ask Driver to Briefly Open GoHawk</h3>
  <p>
    SANDi hasn't heard from this driver in more than 15 minutes. If you complete this order, you will lose their in &
    out time. Please ask the driver to briefly open GoHawk so SANDi can update their status.
  </p>

  <div class="actions">
    <button mat-stroked-button color="warn" (click)="complete()">Complete Anyway</button>
    <button mat-stroked-button color="primary" [mat-dialog-close]="null">Ask To Open GoHawk</button>
  </div>
</ng-template>
